<template>
  <b-button size="-small" variant="-ternary btn--outline btn--border-light btn--small-icon" @click="showModal=true">
    <svg class="icon icon--info">
      <use xlink:href="#info-icon"></use>
    </svg>
    <b-modal v-if="showModal" v-model="showModal" modal-class="modal--edit" size="lg">
      <file-gcode-info :file-id="file.id"/>
      <template v-slot:modal-footer="{ cancel }">
        <div class="modal__footer--left">
          <b-button variant="-ternary btn--outline" @click="cancel()">
            {{$t('buttons.cancel')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="handlePrint(cancel)">
            {{$t('buttons.print')}}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-button>
</template>

<script>
  import FileGcodeInfo from "@/components/files/modal/FileGcodeInfo";

  export default {
    name: 'file-gcode-info-button',
    components: {FileGcodeInfo},
    props: {
      file: {
        type: Object, required: true
      }
    },
    data() {
      return {
        showModal: null,
      }
    },
    methods: {
      handlePrint(cancelCallback) {
        window.vuePrintFile(this.file.id, this.file.printer_type);
        cancelCallback();
      }
    }
  }
</script>
